import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseText from '@/components/BaseText.vue';
import WhiteLabelContent from '@/components/v2/WhiteLabelContent';
import me from '@/plugins/graphql/queries/me.gql';
import ForgotPasswordDialog from '@/components/v2/auth/ForgotPasswordDialog.vue';
import LoginLinkMixin from '@/helpers/vue_mixins/LoginLinkMixin';
import SignInCmsEmail from '@/plugins/graphql/mutations/v2/auth/sign-in-cms-email.gql';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import UserPilotMixin from '@/helpers/vue_mixins/v2/UserpilotMixin';
import { UserType } from '@/helpers/entities/enums/UserType';
import { email, required } from 'vuelidate/lib/validators';
import AesMixin from '@/helpers/vue_mixins/v2/AesMixin';
import RecaptchaMixin from '@/helpers/mixins/RecaptchaMixin';
let LoginWrapper = class LoginWrapper extends Mixins(Mixins(ViewportSizeMixin, FormValidationsMixin, RecaptchaMixin, SegmentAnalyticsMixin, Mixins(LoginLinkMixin, AesMixin)), AffiliateMixin, UserPilotMixin, RecaptchaMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            email: null,
            password: null,
        };
        this.isLogin = false;
        this.loginWithCredentials = false;
    }
    get isAffiliate() {
        return this.$route.params?.userType === UserType.Affiliate || false;
    }
    miniAppsImageSrc(obj) {
        if (obj) {
            return obj.whiteLabelLogo;
        }
        return require('@/assets/images/logo-chatgenie.png');
    }
    get imageWidth() {
        if (this.xsOnly) {
            return '65vw';
        }
        return '302';
    }
    get imageHeight() {
        if (this.xsOnly) {
            return '104';
        }
        return '79';
    }
    async onSignIn() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            await this.signIn();
        }
    }
    async signIn() {
        const role = this.$route.params.userType;
        if (this.isRobot) {
            this.recaptchaErrorNotifier();
            return;
        }
        return this.$apollo
            .mutate({
            mutation: SignInCmsEmail,
            variables: {
                input: {
                    email: this.encrypt(this.form.email),
                    password: this.encrypt(this.form.password),
                    role,
                },
            },
        })
            .then((result) => {
            const data = result.data.signInCmsEmail;
            const plan = this.$router.currentRoute.query.plan_type;
            const code = this.$router.currentRoute.query.affiliate_code;
            this.$emit('auth:authenticate', [data.jwt, role]);
            this.$emit('auth:reset-store', () => {
                this.successNotification('Signed In Successfully');
                this.$store.commit('navigation_drawer/toggleDrawer');
                if (data.role === UserType.Reseller) {
                    this.$apollo
                        .query({
                        query: me,
                    })
                        .then((meQuery) => {
                        const profile = meQuery.data.me;
                        this.goToAffiliate(profile.uuid);
                    });
                }
                else {
                    this.$router.push(this.buildLoginLink(plan, code, !data.forActivation));
                }
                this.$apollo
                    .query({
                    query: me,
                })
                    .then((meQuery) => {
                    const profile = meQuery.data.me;
                    this.userpilotIdentify(profile.id, {
                        name: `${profile.firstName} ${profile.lastName}`,
                        email: profile.email,
                        role: profile.role,
                    });
                    this.userpilotTrack('User Logged In', {
                        name: `${profile.firstName} ${profile.lastName}`,
                    });
                });
                this.$router.push(this.buildLoginLink(plan, code, true));
            });
            this.$emit('auth:reset-client', data.jwt);
            this.requestDone();
        })
            .catch((e) => {
            this.isLogin = !this.isLogin;
            this.errorNotification(e.message);
            this.requestDone();
        })
            .finally(() => {
            this.isLogin = !this.isLogin;
            this.requestDone();
        });
    }
    toggleForgotPassword() {
        const vm = this;
        vm.$refs.forgotPasswordDialog.toggleForm();
    }
};
__decorate([
    Prop({ type: String, default: 'Sign In with Facebook to create your Mini App' })
], LoginWrapper.prototype, "caption", void 0);
__decorate([
    Prop({
        type: String,
        default: `For the best experience, please use Google Chrome or Safari.`,
    })
], LoginWrapper.prototype, "warning", void 0);
__decorate([
    Prop({
        type: String,
        default: `For issues, please use the recommended browsers.`,
    })
], LoginWrapper.prototype, "smallTextWarning", void 0);
LoginWrapper = __decorate([
    Component({
        components: {
            VueRecaptcha,
            BaseText,
            BaseTextField,
            ActionButton,
            ForgotPasswordDialog,
            WhiteLabelContent,
        },
        validations: {
            form: {
                email: {
                    email,
                    required,
                },
                password: {
                    required,
                },
            },
        },
    })
], LoginWrapper);
export default LoginWrapper;
